import { gql } from 'graphql-request'
import {
  examFragment,
  fullBookFragment,
  fullSectionFragment,
  schoolResourceFragment,
  simpleBookFragment,
  simpleSectionFragment,
} from './fragments'

export const Books_Listing = gql`
  query Books_Listing {
    books(orderBy: [{ column: ORDER_COLUMN, order: ASC }]) {
      data {
        ...simpleBook
      }
    }
  }
  ${simpleBookFragment}
`

export const Library_Books = gql`
  query Library_Books {
    libraryBooks(orderBy: [{ column: ORDER_COLUMN, order: ASC }]) {
      data {
        ...simpleBook
      }
    }
  }
  ${simpleBookFragment}
`

export const Search = gql`
  query Search($term: String!, $type: String) {
    search(term: $term, type: $type) {
      __typename
      ... on Book {
        ...simpleBook
      }
      ... on Section {
        ...simpleSection
      }
    }
  }
  ${simpleBookFragment}
  ${simpleSectionFragment}
`

export const Single_Book = gql`
  query Single_Book($id: ID!) {
    book(id: $id) {
      id
      name
      description
      image
      public
      published
      isHidden
      level {
        id
        name
      }
      schoolYear {
        id
        name
      }
      subject {
        id
        name
        slug
      }
      subjectAreaTexts {
        id
        text
        orderColumn
        subjectArea {
          id
          name
          orderColumn
        }
      }
      sections {
        id
        name
        description
        image
        content
        teachersGuideContent
        updated_at
        published
        schoolYear {
          id
          name
        }
        subject {
          id
          name
          slug
        }
        level {
          id
          name
        }
        subjectAreaTexts {
          id
          text
          orderColumn
          subjectArea {
            id
            name
            orderColumn
          }
        }
        creator {
          id
        }
        tags {
          id
          name
        }
        pivot {
          id
          order_column
        }
        exams {
          ...exam
        }
      }
      creator {
        id
      }
      customers {
        id
      }
      tags {
        id
        name
      }
      created_at
      updated_at
    }
  }
  ${examFragment}
`

export const Shared_Single_Book = gql`
  query Shared_Single_Book($shareLink: String!) {
    sharedBook(shareLink: $shareLink) {
      ...fullBook
    }
  }
  ${fullBookFragment}
`

export const Public_Single_Book = gql`
  query Public_Single_Book($id: ID!) {
    publicBook(id: $id) {
      id
      name
      description
      image
      public
      published
      isHidden
      level {
        id
        name
      }
      schoolYear {
        id
        name
      }
      subject {
        id
        name
        slug
      }
      subjectAreaTexts {
        id
        text
        orderColumn
        subjectArea {
          id
          name
          orderColumn
        }
      }
      sections {
        id
        name
        description
        image
        content
        teachersGuideContent
        updated_at
        published
        schoolYear {
          id
          name
        }
        subject {
          id
          name
          slug
        }
        level {
          id
          name
        }
        subjectAreaTexts {
          id
          text
          orderColumn
          subjectArea {
            id
            name
            orderColumn
          }
        }
        pivot {
          id
          order_column
        }
      }
      creator {
        id
      }
      customers {
        id
      }
      tags {
        id
        name
      }
      created_at
      updated_at
    }
  }
`

export const Instruction_Book = gql`
  query Instruction_Book {
    instructionBook {
      id
      name
      description
      image
      public
      published
      isHidden
      level {
        id
        name
      }
      schoolYear {
        id
        name
      }
      subject {
        id
        name
        slug
      }
      subjectAreaTexts {
        id
        text
        orderColumn
        subjectArea {
          id
          name
          orderColumn
        }
      }
      sections {
        id
        name
        description
        image
        content
        teachersGuideContent
        updated_at
        published
        schoolYear {
          id
          name
        }
        subject {
          id
          name
          slug
        }
        level {
          id
          name
        }
        subjectAreaTexts {
          id
          text
          orderColumn
          subjectArea {
            id
            name
            orderColumn
          }
        }
        pivot {
          id
          order_column
        }
      }
      creator {
        id
      }
      customers {
        id
      }
      tags {
        id
        name
      }
      created_at
      updated_at
    }
  }
`

export const Sections_Listing = gql`
  query Sections_Listing {
    sections(orderBy: [{ column: CREATED_AT, order: DESC }]) {
      data {
        ...simpleSection
      }
    }
  }

  ${simpleSectionFragment}
`

export const Library_Sections = gql`
  query Library_Sections {
    librarySections(orderBy: [{ column: CREATED_AT, order: DESC }]) {
      data {
        ...simpleSection
      }
    }
  }

  ${simpleSectionFragment}
`

export const Single_Section = gql`
  query Single_Section($id: ID!) {
    section(id: $id) {
      ...fullSection
    }
  }
  ${fullSectionFragment}
`

export const Public_Single_Section = gql`
  query Public_Single_Section($id: ID!) {
    section: publicSection(id: $id) {
      ...fullSection
    }
  }
  ${fullSectionFragment}
`

export const Shared_Single_Section = gql`
  query Shared_Single_Section($shareLink: String!) {
    section: sharedSection(shareLink: $shareLink) {
      ...fullSection
    }
  }
  ${fullSectionFragment}
`

export const Single_School = gql`
  query Single_School($id: ID) {
    school(id: $id) {
      id
      name
      students {
        id
        first_name
        last_name
        email
        username
        schoolClasses {
          id
        }
      }
      schoolGroups {
        id
        name
        creator {
          id
          first_name
          last_name
          image
        }
        students {
          id
        }
        books {
          id
          pivot {
            sharedBy {
              id
              first_name
              last_name
              image
            }
          }
        }
      }
      schoolClasses {
        id
        name
        isPrivate
        customer {
          id
        }
        students {
          id
        }
        books {
          id
        }
      }
    }
  }
`

export const SchoolClasses_Listing = gql`
  query SchoolClasses_Listing($id: ID!) {
    schoolClasses(customer_id: $id) {
      data {
        id
        name
        isPrivate
        customer {
          id
        }
        school {
          id
          name
        }
        students {
          id
        }
        books {
          id
        }
      }
    }
  }
`

export const SchoolGroups_Listing = gql`
  query SchoolGroups_Listing($id: ID!) {
    schoolGroups(creator_id: $id) {
      data {
        id
        name
        creator {
          id
          first_name
          last_name
          image
        }
        school {
          id
          name
        }
        students {
          id
        }
        books {
          id
        }
      }
    }
  }
`

export const Single_SchoolClass = gql`
  query Single_SchoolClass($id: ID!) {
    schoolClass(id: $id) {
      isPrivate
      ...schoolResource
    }
  }

  ${schoolResourceFragment}
`

export const Single_SchoolGroup = gql`
  query Single_SchoolGroup($id: ID!) {
    schoolGroup(id: $id) {
      ...schoolResource
    }
  }

  ${schoolResourceFragment}
`

export const School_Students_Listing = gql`
  query School_Students_Listing($id: ID!) {
    customers(school_id: $id, role_id: 3) {
      id
      first_name
      last_name
      email
    }
  }
`

export const Item_Settings = gql`
  query Item_Settings {
    subjects {
      data {
        id
        name
        slug
      }
    }

    subjectAreas {
      data {
        id
        name
        orderColumn
      }
    }

    schoolYears {
      data {
        id
        name
      }
    }

    levels {
      data {
        id
        name
      }
    }

    tags {
      data {
        id
        name
      }
    }
  }
`

export const Subject_Areas = gql`
  query Subject_Areas($id: ID!) {
    subjectAreas(subject_id: $id) {
      data {
        id
        name
        orderColumn
        subjectAreaTexts {
          id
          text
          schoolYear {
            id
          }
          subject {
            id
            name
            slug
          }
          subjectArea {
            id
            name
          }
        }
      }
    }
  }
`

export const Single_Student = gql`
  query Single_Student($id: ID!) {
    customer(id: $id) {
      id
      first_name
      last_name
      schoolClasses {
        id
        name
        customer {
          id
          first_name
          last_name
          image
        }
        books {
          id
          name
          image
          subject {
            id
            name
            slug
          }
          sections {
            id
            image
            exams {
              ...exam
            }
          }
          pivot {
            id
            school_class_id
            created_at
            sharedBy {
              first_name
              last_name
              image
            }
            is_archived
          }
        }
      }
      schoolGroups {
        id
        name
        creator {
          id
          first_name
          last_name
          image
        }
        books {
          id
          name
          image
          subject {
            id
            name
            slug
          }
          sections {
            id
            image
            exams {
              ...exam
            }
          }
          pivot {
            id
            school_class_id
            created_at
            sharedBy {
              first_name
              last_name
              image
            }
            is_archived
          }
        }
      }
    }
  }
  ${examFragment}
`

export const Current_User = gql`
  query Current_User {
    currentUser {
      id
      userRole
      role_id
      first_name
      last_name
      email
      image
      acceptedEula
      seen_popups
      hasVisitedLibrary
      hasVisitedHelp
      hasCreatedStudents
      hasCreatedSchoolGroups
      hasSharedBooks
      hasSharedGroupBooks
      hasCreatedBooks
      hasClosedHelpTooltip
      showTooltips
      onboardingLevel
      hasValidPubAgreement
      hasPaidLicense
      books {
        id
      }
      sharedBooks {
        id
      }
      schools {
        id
        name
        schoolClasses {
          id
          name
          isPrivate
        }
        students {
          id
          first_name
          last_name
          email
        }
      }
      schoolClasses {
        id
        name
        isPrivate
      }
    }
  }
`

export const User_SchoolClasses = gql`
  query User_SchoolClasses {
    currentUser {
      schoolClasses {
        id
        isPrivate
        name
        customer {
          id
        }
        school {
          id
          name
        }
        students {
          id
        }
        books {
          id
        }
      }
    }
  }
`

export const DemoResources = gql`
  query DemoResources($id: ID!, $connected: Boolean) {
    demoSchoolClasses(customer_id: $id, connected: $connected) {
      id
      name
      students {
        id
        first_name
        last_name
      }
      books {
        id
        name
        image
        subject {
          id
          name
          slug
        }
        sections {
          id
          image
        }
        pivot {
          id
          demo_school_class_id
          created_at
        }
      }
    }
    demoSchoolGroups(customer_id: $id, connected: $connected) {
      id
      name
      students {
        id
        first_name
        last_name
        email
        username
      }
      books {
        id
        name
        image
        subject {
          id
          name
          slug
        }
        sections {
          id
          image
        }
        pivot {
          id
          demo_school_group_id
          created_at
        }
      }
    }
  }
`

export const Startpage_Blocks = gql`
  query Startpage_Blocks {
    startpageBlocks(orderBy: [{ column: ORDER_COLUMN, order: ASC }]) {
      id
      blockType
      heading
      text
      books {
        ...simpleBook
      }
      sections {
        ...simpleSection
      }
    }
  }
  ${simpleBookFragment}
  ${simpleSectionFragment}
`
